import { hasFiltersApplied } from '#src/app/pages/searchV2/shared/api';

import { useSearchState } from '../useSearchState';

export function useHasFiltersApplied(): boolean {
	return hasFiltersApplied(useSearchState());
}
